import styled from "styled-components";

const getButtonStyles = (type) => {
    switch (type) {
        case 'critical':
            return `
                background: rgba(176, 42, 55, 0.15);
                border: 1px solid rgba(176, 42, 55, 0.6);
                color: #FFFFFF;

                &:hover:not(:disabled) {
                    background: rgba(176, 42, 55, 0.28);
                    filter: drop-shadow(2px 2px rgba(0,0,0,0.15));
                    transform: scale(1.015);
                }
            `;
        case 'default':
        default:
            return `
                background: none;
                border: 1px solid rgba(255,255,255,0.4);
                color: #FFFFFF;

                &:hover:not(:disabled) {
                    background: rgba(255,255,255,0.4);
                    filter: drop-shadow(2px 2px rgba(0,0,0,0.15));
                    transform: scale(1.015);
                }
            `;
    }
};

export const SecondaryBtnContainer = styled.button`
    border-radius: 4px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    font-size: 12px;
    font-weight: 600;
    height: 40px;
    min-width: 160px;
    opacity: ${({ disabled }) => (disabled ? "0.25" : "1.0")};
    transition: 0.3s ease-in-out;
    ${({ $type }) => getButtonStyles($type)}
`;